import * as types from '../constants/actionTypes';
import * as auth from '../tools/auth0.cred';
import * as api from '../tools/apiConfig';
import jQuery from 'jquery';
import axios from 'axios';
import { history } from '../store/configureStore';
import toastr from 'toastr';
import moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getSpecialistBlocksList } from './specialistActions.js'

//importing specialistAction here so we can dispatch
// getAppointmentsForMonth and getAppointmentsForDay after deleting appoinment
import * as specialistAction from './specialistActions';

let userToken = localStorage.getItem('token');
let specialistId = localStorage.getItem('userId');
let obj = {
	userToken: userToken,
	specialistId: specialistId,
	// userlocation: moment.tz.guess()
};
export function getAppointments(data, props) {

	return function (dispatch, getState) {
		axios.post(api.GET_APPOINTMENTS, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': localStorage.token
			}
		})
			.then(function (response) {

				;
				if (response.data.code == 200) {
					if (data) {
						response.data.data.specialists = data.user;
						response.data.data.per_page = data.per_page;
						return dispatch({ type: types.GET_APPOINTMENTS, appointmentList: response.data.data })
					}
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) {

			});
	}
}

export function getAppointmentDetailWithRate(data, props) {
	return function (dispatch, getState) {
		axios.post(api.GET_APPOINTMENT_DETAIL_RATE, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					if (data) {
						return dispatch({ type: types.GET_APPOINTMENT_DETAIL_RATE, appointmentRateDetail: response.data.data })
					}
				} else if (response.data.code == 402) {
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });
	}
}

export function deleteAppointment(data, props) {
	return function (dispatch, getState) {
		var delObj = {
			appointmentId: data.appointmentId,
			patientId: data.patientId,
			userType: data.userType
		};
		axios.post(api.DELETE_APPOINTMENT, delObj, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					toast.info("Your Appointment has been cancelled");
					if (data) {
						var userData = JSON.parse(localStorage.getItem('user'));
						var aptObj = {
							flag: data.flag,
							count: data.count,
							page: data.page,
						}
						if (userData.type == 'patient') {

							aptObj.patientId = localStorage.getItem('userId');

						}
						if (userData.type == 'specialist') {

							aptObj.specialistId = localStorage.getItem('userId');

						}
						axios.post(api.GET_APPOINTMENTS, aptObj, {
							headers: {
								'Content-Type': 'application/json',
								'Authorization': localStorage.token
							}
						})
							.then(function (response) {

								if (response.data.code == 200) {
									if (data) {
										var doctorId = { 'specialistId': localStorage.getItem('userId') }
										// toast.info(" Your Appointment has been cancelled");
										response.data.data.specialists = data.user;
										response.data.data.per_page = data.per_page;
										return dispatch({ type: types.GET_APPOINTMENTS, appointmentList: response.data.data });

									}
								} else if (response.data.code == 402) {
									localStorage.clear();
									props.history.push('/');
									toastr.error(response.data.message);
								}
								else {
									// toast.info(" Your Appointment has been cancelled");
									response.data.data.specialists = data.user;
									response.data.data.per_page = data.per_page;
									return dispatch({ type: types.GET_APPOINTMENTS, appointmentList: response.data.data });

								}
							})
							.catch(function (error) { });
						//  Getting appoinments for the day
						let userToken = localStorage.getItem('token');
						let specialistId = localStorage.getItem('userId');

						let settingsObj = {
							token: userToken,
							doctorId: specialistId
						};
						specialistAction.getAppointmentsForDay(settingsObj)(dispatch);
						specialistAction.getAppointmentsForMonth(settingsObj)(dispatch);
					}
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });
	}
}
export function getSpecialistAvailability(data, props) {



	return function (dispatch, getState) {
		axios.post(api.GET_SPECIALISTAVABILITY, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {

				if (response.data.code == 200) {
					if (data) {

						return dispatch({ type: types.GET_SPECIALISTAVABILITY, specialistAvailability: response.data.data })
					}
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) {

			});
	}
}
export function bookAppointment(data, props) {

	return function (dispatch, getState) {
		axios.post(api.BOOK_APPOINTMENT, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					if (data.createdBy == 'Specialist') {
						localStorage.appointmentId = response.data.data.appointmentData._id
						let addAppointmentObj = {
							isConfirm: true,
							appointmentId: response.data.data.appointmentData._id,
							paymentMethod: data.paymentMethod,
							createdBy: 'Specialist',
							isUserNew: !response.data.data.isEmailExist,
							userlocation: moment.tz.guess(),
							patientId: response.data.data.patientDetails._id,
							appointmentMode: data.appointmentMode,
							userCreatedBy: response.data.data.userCreatedBy ? response.data.data.userCreatedBy : 'O'

						};
						console.log("==>>patientdetails form==>", addAppointmentObj)
						props.appointmentactions.addAppointmentDetails(addAppointmentObj, props);
					} else if (response.data.data) {
						localStorage.appointmentId = response.data.data.appointmentData._id

						props.history.push('/dashboard/appointment-details');
						return dispatch({ type: types.BOOK_APPOINTMENT, appointmentData: response.data.data })
					}
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });
	}
}
export function addAppointmentDetails(data, props) {
	return function (dispatch, getState) {
		axios.post(api.ADD_APPOINTMENT_DETAILS, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					if (data.createdBy == 'Specialist') {
						toast.info('Appointment Has been created')
						props.closeBlockAvailability();
					}
					if (data.paymentMethod == 'cash') {
						let appointmentObj = {
							appointmentId: localStorage.getItem('appointmentId'),
							paymentMethod: data.paymentMethod,
							createdBy: data.createdBy,
							isUserNew: false
						}
						props.actions.getAppointmentDetails(appointmentObj, props);
						// return 
					} else if (data.isConfirm == true && data.paymentMethod == 'card') {
						// localStorage.removeItem('availabilityId');
						// localStorage.removeItem('slot');
						// specialist blocked for this route
						props.history.push('/dashboard/appointment-payment');
					} else {
						if (data.userCreatedBy == 'S') {
							console.log("DASHBORADTRIGGERED")
							props.history.push({
								pathname: '/dashboard/appointment-confirmation',
								data: {
									appointmentId: data.appointmentId
								}
							})
						}else
							props.history.push('/dashboard/appointment-confirmation');
					}
					return dispatch({ type: types.ADD_APPOINTMENT_DETAILS, addAppointmentDetails: response.data.data })
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				} else {
					let appointmentObj = {
						appointmentId: localStorage.getItem('appointmentId'),
					}
					props.actions.getAppointmentDetails(appointmentObj, props);
				}
			})
			.catch(function (error) { });
	}
}

export function getAppointmentDetails(data, props) {
	// debugger
	return function (dispatch, getState) {
		axios.post(api.GET_APPOINTMENT_DETAILS, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(async function (response) {
				
				if (response.data.code == 200) {
					if (data.paymentMethod == 'cash') {
						let userlocation = moment.tz.guess()

						var card = {
							"number": '4242424242424242',
							"exp_month": '12',
							"exp_year": '24',
							"cvc": '345',
							"nameOnCard": 'Medfix',
							"postalCode": '160059',
							"country": 'India'
						}
						var patientId = localStorage.getItem('userId');
						await props.actions.makepayment({ 'carddetails': card,
							userlocation ,  'patientId': patientId,
							'appointmentId': localStorage.getItem('appointmentId'),
							'paymentMethod': 'cash'
						});
						if (data.createdBy === 'Specialist') {
							toast.info("Appointment has been created")
						} else {
							if (data.paymentMethod != 'cash')
							axios.post(api.SEND_CASH_APPOINTMENT_EMAIL, {data: response.data,
								userlocation: localStorage.getItem('userlocation'),
								clinicCountryZone: localStorage.getItem('clinicCountryZone') }, {
								headers: {
									'Content-Type': 'application/json',
									'Authorization': 'Bearer ' + localStorage.token
								}
							}).then(function (response) {
								if(response.data.code == 200) {
									
									props.history.push('/dashboard/booking-confirmation');
								}
								// props.history.push('/dashboard/my-appointment');
							});
							else
							    props.history.push('/dashboard/booking-confirmation');
						}
					} else if (data.bookingConfirm) {
						localStorage.removeItem('appointmentId');
					}
					return dispatch({ type: types.GET_APPOINTMENT_DETAILS, appointmentDetails: response.data.data.appointmentRecord })
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });
	}
}

export function cancelAppointment(data, props) {

	return function (dispatch, getState) {
		axios.post(api.CANCEL_APPOINTMENT, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					toast.info("Your Appointment has been cancelled");
					props.actions.getAppointmentsForMonth(data.settingsObj);
					props.actions.getAppointmentsForDay(data.settingsObj);
					localStorage.removeItem('appointmentId');
					localStorage.removeItem('availabilityId');
					// props.history.push('/dashboard/book-appointment');
					// props.history.push('/dashboard/appointment-details');
					return dispatch({ type: types.CANCEL_APPOINTMENT, appointmentCancel: response.data.data })
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });
	}
}

export function getPatientHistory(data, props) {
	return function (dispatch, getState) {
		axios.post(api.GET_PATIENT_HISTORY, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					return dispatch({ type: types.GET_PATIENT_HISTORY, patientHistory: response.data.data })
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });
	}
}

export function getSpecialistDetailCalendar(data, props) {
	return function (dispatch, getState) {
		axios.post(api.GET_SPECIALIST_DETAIL_CALENDAR, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					return dispatch({ type: types.GET_SPECIALIST_DETAIL_CALENDAR, specialistDetailsCalendar: response.data.data })
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });
	}
}

export function updateAppointmentShowDetails(data, props) {
	return function (dispatch, getState) {
		axios.post(api.UPDATE_APPOINTMENT_SHOW, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					//   debugger;
					let userToken = localStorage.getItem('token');
					let specialistId = localStorage.getItem('userId');
					let appointmentObj = {
						token: userToken,
						specialistId: specialistId,
						flag: 1,
						count: 10,
						page: 1
					};
					axios.post(api.GET_APPOINTMENTS, appointmentObj, {
						headers: {
							'Content-Type': 'application/json',
							'Authorization': localStorage.token
						}
					})
						.then(function (response) {
							;
							if (response.data.code == 200) {
								if (data) {
									response.data.data.specialists = data.user;
									response.data.data.per_page = data.per_page;
									return dispatch({ type: types.GET_APPOINTMENTS, appointmentList: response.data.data })
								}
							} else if (response.data.code == 402) {
								localStorage.clear();
								props.history.push('/');
								toastr.error(response.data.message);
							}
						})
						.catch(function (error) { });
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });
	}
}

export function saveConsultation(data, props) {
	

	// debugger
	var doctorId = { 'specialistId': data.doctorId }
	return function (dispatch, getState) {
		axios.post(api.SAVE_CONSULTATION, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				
				if (response.data.code == 200) {

					axios.post(api.GET_APPOINTMENTS_COUNT, doctorId, {
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + localStorage.token
						}
					})
						.then(function (response) {

							if (response.data.code == 200) {
								toast.info("Saved successfully");
								props.history.push('/specialist/my-appointment');
								if (data) {

									return dispatch({ type: types.GET_APPOINTMENTS_COUNT, appointmentsCount: response.data.data })
								}
							} else if (response.data.code == 402) {
								toast.info('Consultation Failed')
								// props.history.push('/specialist/my-appointment');
							}
						})
						.catch(function (error) {
						});
					// return dispatch({ type: types.UPDATE_APPOINTMENT_SHOW, specialistDetailsCalendar: response.data.data })
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });
	}
}

export function getConsultationDetail(data, props) {
	return function (dispatch, getState) {
		axios.post(api.GET_CONSULTATION_DETAIL, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					return dispatch({ type: types.GET_CONSULTATION_DETAIL, consultationDet: response.data.data })
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });
	}
}

export function getPatientAllHistory(data, props) {

	return function (dispatch, getState) {
		axios.post(api.GET_PATIENT_ALL_HISTORY, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {

				if (response.data.code == 200) {
					return dispatch({ type: types.GET_PATIENT_ALL_HISTORY, patientAllHistory: response.data.data })
				} else if (response.data.code == 402) {

					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) {

			});
	}
}

export function createSessionIdToken(data, props) {

	return function (dispatch, getState) {
		axios.post(api.CREATE_SESSIONID_TOKEN, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {

				if (response.data.code == 200) {

					return dispatch({ type: types.CREATE_SESSIONID_TOKEN, sessionData: response.data.data })
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) {

			});
	}
}
export function disconnectSessionIdToken(data, props) {
	let connectionData = {
		sessionId: data.sessionId,
		token: data.token
	}
	return function (dispatch, getState) {
		axios.post(api.DISCONNECT_SESSIONID_TOKEN, connectionData, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					return dispatch({ type: types.DISCONNECT_SESSIONID_TOKEN, sessionData: response.data.data })
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });
	}
}


export function getPatientAllConsultHistory(data, props) {
	return function (dispatch, getState) {
		axios.post(api.GET_PATIENT_ALL_CONSULT_HISTORY, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {

				if (response.data.code == 200) {
					return dispatch({ type: types.GET_PATIENT_ALL_CONSULT_HISTORY, patientAllConsultHistory: response.data.data })
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) {


			});
	}
}


export function getRatingQuestions() {
	return function (dispatch, getState) {
		axios.get(api.GET_RATING_QUESTIONS, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {

				if (response.data.code == 200) {
					return dispatch({ type: types.GET_RATING_QUESTIONS, ratingQuestions: response.data.data });
				}
			})
			.catch(function (error) {
			});
	}
}

export function noShowAppointment(data, props) {

	return function (dispatch, getState) {
		axios.post(api.NO_SHOW_APPOINTMENT, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {

					if (data) {
						return dispatch({ type: types.NO_SHOW_APPOINTMENT, noShowappointmentList: response.data.data })
					}
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) {

			});
	}
}

export function addRating(data, props) {
	return function (dispatch, getState) {
		axios.post(api.ADD_RATING, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					toast.info(response.data.message);
					// props.history.push('/my-appointment');
					return dispatch({ type: types.ADD_RATING, pendingRate: response.data.data, ratingSucess: false });
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
					return dispatch({ type: types.ADD_RATING, ratingSucess: false });
				}
			})
			.catch(function (error) { });
	}
}

export function getAppointmentsForHealthRecord(data, props) {

	return function (dispatch, getState) {
		axios.post(api.GET_APPOINTMENTS_FOR_HEALTH_RECORD, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					if (data) {
						response.data.data.specialists = data.user;
						response.data.data.per_page = data.per_page;
						return dispatch({ type: types.GET_APPOINTMENTS_FOR_HEALTH_RECORD, appointmentList: response.data.data })
					}
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });
	}
}

export function dontRemindAgain(data, props) {
	return function (dispatch, getState) {
		axios.post(api.DONT_REMIND_FEEDBACK_AGAIN, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					toast.info(response.data.message);
					return dispatch({ type: types.DONT_REMIND_FEEDBACK_AGAIN, pendingRate: response.data.data });
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });
	}
}

export function makepayment(data, props) {
	return function (dispatch, getState) {
		axios.post(api.STRIPE_PAYMENT, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					if (data.paymentMethod == 'cash')
						toast.info("Appointment Has been Created");
					else 
						toast.info(response.data.message);
					return dispatch({ type: types.STRIPE_PAYMENT, paymentDetails: response.data.data });
				} else if (response.data.code == 402) {
					// localStorage.clear();
					// props.history.push('/');
					toast.error(response.data.message);
					return dispatch({ type: types.STRIPE_PAYMENT, paymentDetails: response.data.data });
				} else if (response.data.code == 401) {
					toast.error(response.data.description.message);
					return dispatch({ type: types.STRIPE_PAYMENT, paymentDetails: response.data.data });
				} else {
					toast.error(response.data.description.message);
					return dispatch({ type: types.STRIPE_PAYMENT, paymentDetails: response.data.data });
				}
			})
			.catch(function (error) { });
	}
}


export function remindLatter(data, props) {
	return function (dispatch, getState) {
		axios.post(api.REMIND_FEEDBACK_LATER, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {

					toast.info(response.data.message);

					return dispatch({ type: types.GET_REMINDER_FEEDBACK, pendingRate: response.data.data });
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toast.error(response.data.message);
				}
			})
			.catch(function (error) { });
	}
}

export function getReminderList(data, props) {
	return function (dispatch, getState) {
		axios.post(api.GET_REMINDER_FEEDBACK, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					return dispatch({ type: types.GET_REMINDER_FEEDBACK, pendingRate: response.data.data });
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });
	}
}

export function getNextReminder(data, props) {
	return function (dispatch, getState) {
		axios.post(api.GET_NEXT_REMINDER, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					return dispatch({ type: types.GET_REMINDER_FEEDBACK, pendingRate: response.data.data });
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });
	}
}


export function editRatingByPatient(data, props) {
	return function (dispatch, getState) {
		axios.post(api.EDIT_FEEDBACK_PATIENT, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					toast.info(response.data.message);
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });
	}
}

export function downloadFile(url, appointmentId, ListData, props) {
	var data = {
		appointmentId: appointmentId
	}
	return function (dispatch, getState) {
		axios({
			url: url,
			method: 'GET',
			responseType: 'blob', // important
		}).then((response) => {
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', 'Prescription.pdf');
			document.body.appendChild(link);
			link.click();



			axios.post(api.UPDATE_IS_DOWNLOAD, data, {
				headers: {
					'Content-Type': 'application/json',
					'Authorization': 'Bearer ' + localStorage.token
				}
			})
				.then(function (response) {
					if (response.data.code == 200) {
						// return dispatch({ type: types.GET_REMINDER_FEEDBACK, pendingRate: response.data.data });
						axios.post(api.GET_APPOINTMENTS_FOR_HEALTH_RECORD, ListData, {
							headers: {
								'Content-Type': 'application/json',
								'Authorization': 'Bearer ' + localStorage.token
							}
						})
							.then(function (response) {
								if (response.data.code == 200) {
									if (data) {
										response.data.data.specialists = data.user;
										response.data.data.per_page = data.per_page;
										return dispatch({ type: types.GET_APPOINTMENTS_FOR_HEALTH_RECORD, appointmentList: response.data.data })
									}
								} else if (response.data.code == 402) {
									localStorage.clear();
									props.history.push('/');
									toastr.error(response.data.message);
								}
							})
							.catch(function (error) { });
					} else if (response.data.code == 402) {
						localStorage.clear();
						props.history.push('/');
						toastr.error(response.data.message);
					}
				})
				.catch(function (error) { });
		});
	}
}

export function getBlockAppointmentDate(data, props) {

	return function (dispatch, getState) {
		axios.post(api.GET_SPECIALIST_BLOCK_DATES, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				
				if (response.data.code == 200) {
					return dispatch({ type: types.GET_SPECIALIST_BLOCK_DATES, blockedDates: response.data.data });
				}
			})
			.catch(function (error) {
			});
	}
}

export function weeklyBlockAvailability(data, props) {
	return function (dispatch, getState) {
		let userToken = localStorage.getItem('token');
		let specialistId = localStorage.getItem('userId');
		let obj = {
			userToken: userToken,
			specialistId: specialistId,
			// userlocation: moment.tz.guess()
		};
		axios.post(api.WEEKLY_BLOCK_AVAILABILITY, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					let finalToasterMessage = response.data.message;
					obj.userlocation = moment.tz.guess()

					axios.post(api.GET_SPECIALIST_BLOCKINGS, obj, {
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + localStorage.token
						}
					})
						.then(function (response) {
							if (response.data.code == 200) {
								toast.info(finalToasterMessage);
								props.closeBlockAvailability();
								// localStorage.setItem('availableId',)
								
								return dispatch({
									type: types.GET_SPECIALIST_BLOCKINGS,
									specialistBlockings: response.data.data
								});
							}
						})
						.catch(function (error) {
							
						});
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) {

			});
	}
}
export function monthlyBlockAvailability(data, props) {
	let userToken = localStorage.getItem('token');
	let specialistId = localStorage.getItem('userId');
	let obj = {
		userToken: userToken,
		specialistId: specialistId,
		// userlocation: moment.tz.guess()
	};

	return function (dispatch, getState) {
		axios.post(api.MONTHLY_BLOCK_AVAILABILITY, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {

				if (response.data.code == 200) {
					let finalToasterMessage = response.data.message;
					obj.userlocation = moment.tz.guess()

					axios.post(api.GET_SPECIALIST_BLOCKINGS, obj, {
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + localStorage.token
						}
					})
						.then(function (response) {
							if (response.data.code == 200) {
								toast.info(finalToasterMessage);
								props.closeBlockAvailability();
								// localStorage.setItem('availableId',)
								
								return dispatch({
									type: types.GET_SPECIALIST_BLOCKINGS,
									specialistBlockings: response.data.data
								});
							}
						})
						.catch(function (error) {
							
						});
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) {

			});
	}
}
export function dailyBlockAvailability(data, props) {
	let userToken = localStorage.getItem('token');
	let specialistId = localStorage.getItem('userId');
	let obj = {
		userToken: userToken,
		specialistId: specialistId,
		// userlocation: moment.tz.guess()
	};
	return function (dispatch, getState) {
		axios.post(api.DAILY_BLOCK_AVAILABILITY, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {

				if (response.data.code == 200) {
					let finalToasterMessage = response.data.message;
					obj.userlocation = moment.tz.guess()

					axios.post(api.GET_SPECIALIST_BLOCKINGS, obj, {
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + localStorage.token
						}
					})
						.then(function (response) {
							if (response.data.code == 200) {
								toast.info(finalToasterMessage);
								props.closeBlockAvailability();
								// localStorage.setItem('availableId',)
								
								return dispatch({
									type: types.GET_SPECIALIST_BLOCKINGS,
									specialistBlockings: response.data.data
								});
							}
						})
						.catch(function (error) {
							
						});
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) {

			});
	}
}
export function yearlyBlockAvailability(data, props) {
	
	let userToken = localStorage.getItem('token');
	let specialistId = localStorage.getItem('userId');
	let obj = {
		userToken: userToken,
		specialistId: specialistId,
		// userlocation: moment.tz.guess()
	};
	return function (dispatch, getState) {
		axios.post(api.YEARLY_BLOCK_AVAILABILITY, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				
				if (response.data.code == 200) {
					let finalToasterMessage = response.data.message;
					obj.userlocation = moment.tz.guess()

					// getSpecialistBlocksList(obj);
					axios.post(api.GET_SPECIALIST_BLOCKINGS, obj, {
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + localStorage.token
						}
					})
						.then(function (response) {
							if (response.data.code == 200) {
								toast.info(finalToasterMessage);
								// localStorage.setItem('availableId',)
								
								if (!data.cloningEvent)
									props.closeBlockAvailability();
								return dispatch({
									type: types.GET_SPECIALIST_BLOCKINGS,
									specialistBlockings: response.data.data
								});
							}
						})
						.catch(function (error) {
							
						});
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) {

			});
	}
}
export function updateWeeklyBlockAvailability(data, props) {
	return function (dispatch, getState) {
		axios.post(api.UPDATE_WEEKLY_BLOCK_AVAILABILITY, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {

				if (response.data.code == 200) {
					toast.info(response.data.message);
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) {

			});
	}
}


// view receipt
export function viewReceipt(data, props) {
	return function (dispatch, getState) {
		axios.post(api.GET_APPOINTMENT_RECEIPT, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					if (data) {
						return dispatch({ type: types.GET_APPOINTMENT_RECEIPT, disputedAppointments: response.data })
					}
				} else if (response.data.code == 402) {
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });
	}
}


// get all disputed appointments
export function getAllDisputedAppointments(data, props) {
	return function (dispatch, getState) {
		axios.post(api.GET_DISPUTED_APPOINTMENTS, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					if (data) {
						
						return dispatch({ type: types.GET_DISPUTED_APPOINTMENTS, disputedAppointments: response.data.data })
					}
				} else if (response.data.code == 402) {
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) { });
	}
}
